const { REACT_APP_API_CORE, REACT_APP_API_AFIP } = process.env

export const url = `${REACT_APP_API_CORE}/api`
export const url_login = `${REACT_APP_API_CORE}`
export const url_node = `${REACT_APP_API_CORE}/reports/api/v1`
export const url_api_afip_dev = `${REACT_APP_API_AFIP}/v1`
export const url_api_afip_prod = `${REACT_APP_API_AFIP}/v1`
